var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company"},[_c('img',{attrs:{"src":"/img/zombie/waves-association.svg"},on:{"click":function($event){return _vm.openTab('https://wavesassociation.org')}}}),_c('img',{attrs:{"src":"/img/zombie/psc.svg"},on:{"click":function($event){return _vm.openTab('https://picsell.art')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }